import { render, staticRenderFns } from "./region.vue?vue&type=template&id=749b2e76&scoped=true&"
import script from "./region.vue?vue&type=script&lang=ts&"
export * from "./region.vue?vue&type=script&lang=ts&"
import style0 from "./region.vue?vue&type=style&index=0&id=749b2e76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749b2e76",
  null
  
)

component.options.__file = "region.vue"
export default component.exports